import { ReactElement, ReactNode } from "react"
import { useParams } from "react-router-dom"

import AmendHpDeviceProvider from "./baseProviders/amendHpDeviceProvider"
import useContinueHpDeviceDraft from "../../../../../services/middleware/hooks/devices/lct/useContinueHpDeviceDraft"

interface IContinueHpDeviceAmendmentUrlParams {
    deviceRef: string
}

interface IContinueHpDeviceAmendmentProviderProps {
    children: ReactNode
}

const ContinueHpDeviceAmendmentProvider = ({
    children,
}: IContinueHpDeviceAmendmentProviderProps): ReactElement => {
    const { deviceRef: urlDeviceRef } = useParams<
        keyof IContinueHpDeviceAmendmentUrlParams
    >() as IContinueHpDeviceAmendmentUrlParams

    const {
        data: formData,
        setData: setFormData,
        isLoading,
        error: continueAmendmentError,
        attachmentUUID,
        apiResSystemRef,
    } = useContinueHpDeviceDraft(urlDeviceRef)

    return (
        <AmendHpDeviceProvider
            formData={formData}
            setFormData={setFormData}
            formDataIsLoading={isLoading}
            formDataError={continueAmendmentError}
            attachmentUUID={attachmentUUID ?? undefined}
            systemReference={apiResSystemRef ?? "Not loaded"}
        >
            {children}
        </AmendHpDeviceProvider>
    )
}

export default ContinueHpDeviceAmendmentProvider
